import VisitaControlloEcgList from "./pages/VisitaControloEcgList.vue";

export default {
    VisitaControlloEcgList,
};
